<template>
    <ChangePasswordMail/>
</template>
<script>
import ChangePasswordMail from '../components/security/ChangePasswordMail.vue';
export default {
    components:{
        ChangePasswordMail
    }
};
</script>